import React, { useState, useContext,useEffect} from 'react';
import AuthContext from "flexbiz-core/components/auth/Context";
import Container from 'flexbiz-core/components/AppContainer';
import BottomNavigation from "../BottomNavigation";
import DataWidget from "flexbiz-core/components/DataWidget";
import Counter from "flexbiz-core/components/Counter";
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Grid, 
  Button, 
  CardActionArea,
  Avatar,
  Paper
} from '@mui/material';
import { useHistory } from 'react-router-dom';
//import { formatCurrency } from "flexbiz-core/utils";
// Icons
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ContactsIcon from '@mui/icons-material/Contacts'; 
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import BusinessIcon from '@mui/icons-material/Business';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
function DuAn() {
  const context = useContext(AuthContext);
  const history = useHistory();
  
  return (
    <DataWidget
      limit={10}
      code={"dmdt"}
      condition={{ la_du_an_chu_dau_tu: true, status: true }}
      // Bọc ngoài: Danh sách cuộn ngang
      wrapperProps={{ 
        sx: { 
          mb: 2, 
          display: 'flex', 
          overflowX: 'auto', 
          pb: 2, // Tăng padding bottom để bóng (shadow) của Card không bị cắt
          pt: 1,
          px: 0.5,
          gap: 2, 
          '&::-webkit-scrollbar': { display: 'none' },
          scrollSnapType: 'x mandatory' // Giúp cuộn vuốt trên mobile mượt và "hút" vào từng thẻ
        } 
      }}
      renderItem={(row, index, rows) => {
        const path = row.picture ? `${context.config.server_url}${row.picture}?access_token=${context.config.public_token}&size=M` : '';
        const max_ty_le_hh = Math.max(...(row.chinh_sach_hoa_hong || []).map(r => r.ty_le_hh || 0), 0);

        // ================= GIẢI QUYẾT BÀI TOÁN WIDTH =================
        // Nếu chỉ có 1 dự án: Mobile (xs) kéo 100%, Tablet/PC (sm trở lên) giữ 280px
        // Nếu có nhiều dự án: Giữ cố định 260px để cuộn ngang
        const cardWidth = rows.length === 1 ? { xs: '100%', sm: 280 } : 260;
        // ==============================================================

        return (
          <Card 
            key={row._id} 
            sx={{
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 3, 
              flexShrink: 0,
              width: cardWidth,
              scrollSnapAlign: 'start', // Điểm neo khi cuộn mobile
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              border: '1px solid #f0f0f0',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 8px 24px rgba(0,0,0,0.1)' }
            }}
          >
            <CardActionArea 
              onClick={() => history.push(`/view/dmdt_bds_agent/${row._id}`)}
              sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
            >
              
              {/* ================= GIẢI QUYẾT BÀI TOÁN ẢNH BỂ ================= */}
              {/* Sử dụng aspectRatio '16/9' thay cho height: 90 cố định */}
              <Box 
                sx={{ 
                  width: '100%', 
                  aspectRatio: '16/9', 
                  backgroundImage: `url(${path})`, 
                  backgroundSize: 'cover', 
                  backgroundPosition: 'center',
                  bgcolor: '#f5f5f5' // Màu nền chờ khi ảnh đang tải
                }} 
              />
              {/* ============================================================== */}

              <CardContent sx={{ p: 2, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <Typography 
                  variant="subtitle1" 
                  fontWeight="bold" 
                  sx={{ 
                    lineHeight: 1.3, 
                    mb: 1,
                    display: '-webkit-box', 
                    WebkitLineClamp: 2, // Chống vỡ layout nếu tên dự án quá dài (tối đa 2 dòng)
                    WebkitBoxOrient: 'vertical', 
                    overflow: 'hidden' 
                  }}
                >
                  {row.ten_dt || 'Dự án chưa cập nhật tên'}
                </Typography>

                {/* Nhãn Hoa Hồng nổi bật */}
                <Box display="flex" alignItems="center" color="#059669" mt="auto" sx={{ bgcolor: '#ecfdf5', px: 1, py: 0.5, borderRadius: 1, alignSelf: 'flex-start' }}>
                  <BusinessIcon sx={{ fontSize: 16, mr: 0.5 }} />
                  <Typography variant="caption" fontWeight="bold">
                    {`Hoa hồng tới ${max_ty_le_hh}%`}
                  </Typography>
                </Box>
              </CardContent>
            </CardActionArea>
            
            {/* Nút Bán ngay luôn nằm dưới đáy Card */}
            <Box sx={{ p: 2, pt: 0, mt: 'auto' }}>
              <Button
                variant="contained"
                fullWidth
                disableElevation // Bỏ bóng đổ mặc định của MUI
                startIcon={<AddShoppingCartIcon sx={{ fontSize: '1.1rem' }} />}
                onClick={() => history.push(`/ctv-sales/${row.ma_dt}`)} 
                sx={{ 
                  bgcolor: '#fff3e0', // Nền màu cam pastel cực nhạt
                  color: '#e65100',   // Chữ màu cam đậm (tương phản tốt)
                  border: '1px solid #ffe0b2', // Viền mỏng tạo cảm giác tinh tế
                  textTransform: 'none',
                  borderRadius: 2,
                  fontWeight: 'bold',
                  boxShadow: 'none', // Xóa hoàn toàn bóng đổ gắt
                  transition: 'all 0.2s',
                  '&:hover': { 
                    bgcolor: '#ffe0b2', // Nền đậm hơn một chút khi hover
                    transform: 'scale(1.03)', // Hiệu ứng phóng to nhẹ giống nút Gọi điện
                    boxShadow: '0 2px 8px rgba(230, 81, 0, 0.1)' // Thêm bóng mờ khi hover
                  }
                }}
              >
                Bán ngay
              </Button>
            </Box>
          </Card>
        );
      }}
    />
  )
}

function BrokerDashboard() {
  const [expanded, setExpanded] = useState(false);
  const history = useHistory();
  const context = useContext(AuthContext);

  // KIỂM TRA QUYỀN TRUY CẬP (ROLE-BASED CHECK)
  const isPublicUser = context.userInfo?.email === "public";
  const group_name = (context.appInfo?.par?.group?.group_name || "").toLowerCase();
  const isBroker = group_name.indexOf("môi giới") >= 0;

  // NẾU CHƯA ĐĂNG NHẬP HOẶC KHÔNG PHẢI MÔI GIỚI
  if (isPublicUser || !isBroker) {
    return (
      <Box sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f4f6f8' }}>
        <Paper elevation={0} sx={{ p: 4, borderRadius: 4, textAlign: 'center', maxWidth: 400, bgcolor: 'white', boxShadow: '0 8px 32px rgba(0,0,0,0.05)' }}>
          <Avatar sx={{ bgcolor: '#e3f2fd', color: '#1976d2', width: 64, height: 64, mx: 'auto', mb: 2 }}>
            <VerifiedUserIcon fontSize="large" />
          </Avatar>
          
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: '#1a237e' }}>
            Dành riêng cho môi giới
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.6 }}>
            Khu vực này chứa các công cụ và báo cáo thống kê chuyên biệt chỉ dành cho đối tác môi giới. <br/>
            Vui lòng đăng nhập bằng tài khoản môi giới để tiếp tục.
          </Typography>
          
          <Button 
            variant="contained" 
            size="large" 
            fullWidth
            onClick={() => context.signin()}
            color="primary"
          >
            Đăng nhập tài khoản môi giới
          </Button>

          {!isPublicUser && (
            <Button 
              variant="text" 
              sx={{ mt: 2, color: '#ff3b30', textTransform: 'none', fontWeight: 'bold' }}
              onClick={() => context.signout()}
            >
              Đăng xuất tài khoản hiện tại
            </Button>
          )}
        </Paper>
      </Box>
    );
  }
  // NẾU LÀ MÔI GIỚI THÌ RENDER DASHBOARD BÌNH THƯỜNG. pd=12 để không bị bottom bar che mất
  return (
    <Box sx={{
        p: 2, pb: { xs: 10, sm: 12 }, backgroundColor: '#f4f6f8'
      }} >
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: '#1a237e' }}>
        Tổng quan
      </Typography>

      {/* ================= PHẦN 1: CHÍNH SÁCH HOA HỒNG ================= */}
      <Card sx={{ mb: 2, borderRadius: 3, background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', color: 'white' }}>
        <CardContent>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            🚀 Xây dựng đế chế, nhận thu nhập thụ động!
          </Typography>
          
          <Box 
            sx={{ 
              display: '-webkit-box',
              WebkitLineClamp: expanded ? 'unset' : 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              mb: 1
            }}
          >
            <Typography variant="body2" sx={{ lineHeight: 3, opacity: 0.9 }}>
              Trở thành thủ lĩnh thị trường ngay hôm nay! Nhận ngay mức hoa hồng trực tiếp lên đến <b>5%</b> cho mỗi giao dịch thành công. 
              Nhưng đó chưa phải là tất cả! Khi bạn giới thiệu thêm cộng tác viên, bạn sẽ tự động bỏ túi <b>1% hoa hồng gián tiếp</b> từ mọi giao dịch mà họ thực hiện. 
            </Typography>
          </Box>
          
          <Button 
            size="small" 
            onClick={() => setExpanded(!expanded)}
            endIcon={expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            sx={{ color: '#ffeb3b', p: 0, textTransform: 'none', fontWeight: 'bold' }}
          >
            {expanded ? 'Thu gọn' : 'Xem chi tiết chiến lược'}
          </Button>
        </CardContent>
      </Card>

      {/* ================= PHẦN 2: DỰ ÁN NỔI BẬT ================= */}
      <DuAn/>
      {/* ================= PHẦN 3: BÁO CÁO WIDGETS ================= */}
      <Box>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1.5, color: '#333' }}>
          Thống kê của bạn
        </Typography>
        
        <Grid container spacing={2}>
          {/* Widget 1: Lô đã bán */}
          <Grid size={{ xs: 4, sm: 3, md: 3, lg: 3 }} sx={{ display: 'flex' }}>
            <Card sx={{ width: '100%', borderRadius: 3, display: 'flex', flexDirection: 'column', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
              <CardActionArea 
                onClick={() => history.push('/ctv-sales-history')} 
                sx={{ p: 1.5, flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
              >
                <Avatar sx={{ bgcolor: '#e3f2fd', color: '#1976d2', mb: 1, width: 36, height: 36 }}>
                  <TrendingUpIcon fontSize="small" />
                </Avatar>
                <Typography variant="caption" color="text.secondary" display="block" noWrap sx={{ fontSize: '0.7rem' }}>
                  Đã bán
                </Typography>
                <Counter code={"nhadat_moigioi_ban"} condition={{user_created:context.userInfo?.email}} render={count=>{
                  return <Typography variant="subtitle1" fontWeight="bold" color="#1976d2">{count}</Typography>
                }}/>
              </CardActionArea>
            </Card>
          </Grid>

          {/* Widget 2: Khách hàng */}
          <Grid size={{ xs: 4, sm: 3, md: 3, lg: 3 }} sx={{ display: 'flex' }}>
            <Card sx={{ width: '100%', borderRadius: 3, display: 'flex', flexDirection: 'column', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
              <CardActionArea 
                onClick={() => history.push('/ctv-customer')} 
                sx={{ p: 1.5, flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
              >
                <Avatar sx={{ bgcolor: '#f3e5f5', color: '#9c27b0', mb: 1, width: 36, height: 36 }}>
                  <ContactsIcon fontSize="small" />
                </Avatar>
                <Typography variant="caption" color="text.secondary" display="block" noWrap sx={{ fontSize: '0.7rem' }}>
                  Khách hàng
                </Typography>
                <Counter code={"customer"} condition={{isbuyer: true}} render={count=>{
                  return <Typography variant="subtitle1" fontWeight="bold" color="#9c27b0">{count}</Typography>
                }}/>
              </CardActionArea>
            </Card>
          </Grid>

          {/* Widget 3: Mạng lưới CTV */}
          <Grid item size={{ xs: 4, sm: 3, md: 3, lg: 3 }} sx={{ display: 'flex' }}>
            <Card sx={{ width: '100%', borderRadius: 3, display: 'flex', flexDirection: 'column', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
              <CardActionArea 
                onClick={() => history.push('/ctv-network')} 
                sx={{ p: 1.5, flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
              >
                <Avatar sx={{ bgcolor: '#fff8e1', color: '#ff8f00', mb: 1, width: 36, height: 36 }}>
                  <GroupAddIcon fontSize="small" />
                </Avatar>
                <Typography variant="caption" color="text.secondary" display="block" noWrap sx={{ fontSize: '0.7rem' }}>
                  CTV
                </Typography>
                <Counter code={"introducer"} condition={{be_introduced_by:context.userInfo?.email}} render={count=>{
                  return <Typography variant="subtitle1" fontWeight="bold" color="#ff8f00">{count}</Typography>
                }}/>
              </CardActionArea>
            </Card>
          </Grid>

          {/* Widget 4: Hoa hồng */}
          <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }} sx={{ display: 'flex' }}>
            <Card sx={{ width: '100%', borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
              <CardActionArea 
                onClick={() => history.push('/ctv-report')} 
                sx={{ p: 2, display: 'flex', alignItems: 'center' }}
              >
                <Avatar sx={{ bgcolor: '#e8f5e9', color: '#388e3c', mr: 2, width: 48, height: 48 }}>
                  <AccountBalanceWalletIcon />
                </Avatar>
                <Box flexGrow={1}>
                  <Typography variant="body2" color="text.secondary">Hoa hồng</Typography>
                </Box>
              </CardActionArea>
            </Card>
          </Grid>

        </Grid>
      </Box>

    </Box>
  );
}

function HomePage(props) {
  const history = useHistory();
  return (
    <Container 
      {...props} 
      onBack={()=>{
        history.goBack()
      }}
      title={"Trang môi giới"}
    >
      <BrokerDashboard {...props} />
      <BottomNavigation history={history} code={"broker"} />
    </Container>
  );
}
export default HomePage;